import { createVueApp } from '@vuejs/entry';

let ProductBadgeAppPromise;

export const mountProductBadges = async () => {
    if (!ProductBadgeAppPromise) {
        ProductBadgeAppPromise = import(
            /* webpackChunkName: "ProductBadgeApp" */ '@vuejs/apps/ProductBadgeApp.vue'
        ).then((m) => m.default);
    }
    const ProductBadgeApp = await ProductBadgeAppPromise;

    [...document.querySelectorAll('.product-badge-app')]
        .filter((el) => !el.dataset.vueMounted)
        .forEach((el) => {
            const app = createVueApp(ProductBadgeApp);
            const id = JSON.parse(el.dataset.productId || 'null');
            const salePercent = el.dataset.salePercent || null;
            const showPercentPromo = el.dataset.showPercentPromo === 'true';
            const fontSize = el.dataset.fontSize || null;

            app.provide('showPercentPromo', showPercentPromo);

            if (salePercent) app.provide('salePercent', salePercent);
            if (fontSize) app.provide('fontSize', fontSize);

            if (id) app.provide('productId', id);
            app.mount(el);
            el.dataset.vueMounted = '1';
        });
};
